import React from 'react';
import { FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';
import { colors } from 'theme/Variables';

const StyledFormControlLabel = styled(FormControlLabel)`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: 1px solid ${colors.primary['100']};
    border-radius: 10px;
    padding: 7px 10px;
    justify-content: space-between;
    width: 100%;
    font-size: 1.8rem;
    margin: 0 0 20px 0 !important;
    ${({ active }) =>
        active &&
        `
        border:1px solid ${colors.primary['900']};
    `}
    .MuiFormControlLabel-label {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 1.8rem;
        width: 80%;
        position: relative;
        &__option {
            width: 10%;
            font-size: 2.8rem;
            color: ${colors.primary['300']};
            display: flex;
            align-items: center;
            ${({ active }) =>
                active &&
                `
                color: ${colors.secondary['200']};
            `}
        }
        &__wrapper {
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
        &__text {
            width: 100%;
        }
        &__instruction {
            font-size: 1.2rem;
            width: 100%;
        }
    }
`;

const FormControlChooseOption = ({
    control,
    value,
    option,
    label,
    labelPlacement,
    instruction,
    active,
}) => {
    return (
        <StyledFormControlLabel
            control={control}
            value={value}
            labelPlacement={labelPlacement}
            label={
                <div className="d-flex flex-wrap w-100">
                    <div className="MuiFormControlLabel-label__option">{option}</div>
                    <div className="MuiFormControlLabel-label__wrapper">
                        <div className="MuiFormControlLabel-label__text">{label}</div>
                        {instruction && (
                            <div className="MuiFormControlLabel-label__instruction">
                                {instruction}
                            </div>
                        )}
                    </div>
                </div>
            }
            active={active}
        />
    );
};

export default FormControlChooseOption;
